import { DressupClothing } from "GameObjects/StoryGame/ch1/DressupClothing";
import { SceneDraggable } from "GameObjects/StoryGame/SceneDraggable";
import { SceneSpine } from "GameObjects/StoryGame/SceneSpine";
import { TimelineLite } from "gsap";
import * as HLF from "html-living-framework";
import { Application } from "Singletons/Application";
import { Mix } from "Utils/Reflection";

const radius = 200;

export class HorseTarget extends HLF.Input.Receptacle {

    protected acceptedItem: HLF.Input.Draggable;

    constructor(pDraggable: HLF.Input.Draggable) {
        super();
        this.acceptedItem = pDraggable;
    }

    public onLayout() {
        this.hitArea = new PIXI.Circle(0, 0, radius);
    }

    public consume(pDraggable: HLF.Input.Draggable) {
        this.addDraggable(pDraggable);
    }

    protected addDraggable(pDraggable: HLF.Input.Draggable) {
        super.addDraggable(pDraggable);
        PubSub.publishSync('drop', {item: pDraggable, target: this});
        this.isActive = false;
        this._eventData = undefined;
        this._dragged = undefined;
        this._selected = undefined;
        this._isPointerOver = false;
        this.interactive = false;
    }

    protected onDragBegin(pTopic: string, pDraggable: HLF.Input.Draggable) {
        this.isActive = pDraggable === this.acceptedItem;
        super.onDragBegin(pTopic, pDraggable);
    }

    protected onDraggableSelected(pTopic: string, pDraggable: HLF.Input.Draggable) {
        this.isActive = pDraggable === this.acceptedItem;
        super.onDraggableSelected(pTopic, pDraggable);
    }

    protected onPointerOver(): void {
        super.onPointerOver();
        // dragging over
        this.hoverStart();
    }

    protected onPointerOut(): void {
        super.onPointerOut();
        this.hoverEnd();
    }

    protected onPointerMove(pEvent: PIXI.InteractionEvent): void {
        super.onPointerMove(pEvent);
        this.hoverUpdate(pEvent);
    }

    protected onTouchMove(pEvent: PIXI.InteractionEvent): void {
        super.onTouchMove(pEvent);
        this.hoverUpdate(pEvent);
    }

    protected hoverUpdate(pEvent: PIXI.InteractionEvent) {
        if (this._isPointerOver) {
            // mouse over while item is selected
            if (this._selected && this._selected === this.acceptedItem && !this._dragged) {
                const mousePos = pEvent.data.global;
                this.acceptedItem.visuals.position = this.acceptedItem.toLocal(mousePos);
                const yPercent = ((pEvent.data.getLocalPosition(this).y / radius) / 2) + 0.5;
                PubSub.publishSync('hovermove', {item: this._selected, target: this, yPercent});
            }
            // drag over
            else if (this._dragged && this._dragged === this.acceptedItem) {
                const yPercent = ((pEvent.data.getLocalPosition(this).y / radius) / 2) + 0.5;
                PubSub.publishSync('hovermove', {item: this._dragged, target: this, yPercent});
            }
        }
    }

    private hoverStart() {
        if (this._dragged && (this._dragged === this.acceptedItem)) {
            PubSub.publishSync('hover', { item: this._dragged, target: this });
        }

        // mouse over while item is selected
        else if (this._selected && (this._selected === this.acceptedItem)) {
            PubSub.publishSync('hover', { item: this._selected, target: this });
        }
    }

    private hoverEnd() {
        if (this._dragged && (this._dragged === this.acceptedItem)) {
            PubSub.publishSync('hoverend', { item: this._dragged, target: this });
        }

        // mouse over while item is selected
        else if (this._selected && (this._selected === this.acceptedItem)) {
            PubSub.publishSync('hoverend', { item: this._selected, target: this });
        }
    }
}